import { ArrowRightOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router';

/**
 * "→ label" back to a list, with optional info on the other side. `to="back"`
 * returns to the previous page (for pages opened from several places, e.g. an
 * invoice from a member, a meter or the month close).
 */
export function BackBar({
  to = '/',
  label,
  extra,
}: {
  to?: string;
  label: string;
  extra?: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <div className="back-bar">
      {to === 'back' ? (
        <button
          type="button"
          className="back-link back-button"
          onClick={() => navigate(-1)}
        >
          <ArrowRightOutlined /> {label}
        </button>
      ) : (
        <Link to={to} className="back-link">
          <ArrowRightOutlined /> {label}
        </Link>
      )}
      {extra}
    </div>
  );
}
